import { useRouter } from '@capsicum/common-web';
import { useExportAndCloseAccountDrawers } from '@capsicum/features/account/web';
import { useCallback } from 'react';

/**
 * This hook returns a callback to be executed when users click "I dont want to use Socios.com anymore".
 * The callback delivers a modal which allows users to transfer funds or delete account.
 */
export const useV2FTMigrationFAQUserQuits = () => {
	const { push } = useRouter();

	const navToSendFlow = useCallback(() => {
		push('/nc-wallet/send');
	}, [push]);

	const navToDeleteAccountFlow = useCallback(() => {
		push('/settings/account/export-and-close-account?initContent=intro');
	}, [push]);

	const { openTransferFirstWarningModal } = useExportAndCloseAccountDrawers({
		onPrimaryButtonActivate: navToSendFlow,
		onSecondaryButtonActivate: navToDeleteAccountFlow
	});

	return {
		openTransferFirstWarningModal
	};
};
